import produce from 'immer';
import * as _ from 'lodash';

import { errorMessageFromResponse } from '../../helpers/errors';
import { createReducer } from '../utils';

import * as Actions from './actions';
import { AuditLogsStore, UserSelectOption } from './store';

const initialState: AuditLogsStore = {
  status: {
    loading: false,
    errors: [],
  },
  logs: [],
  count: 0,
  topicActionOptions: [],
  userOptions: [],
};

export default createReducer(initialState, {
  [`${Actions.LOAD_AUDIT_LOGS_TASK}_PENDING`]: state => produce(state, draftState => {
    draftState.status.loading = true;
  }),
  [`${Actions.LOAD_AUDIT_LOGS_TASK}_FULFILLED`]: (state, action) => produce(state, draftState => {
    const { payload: { data } } = action;
    draftState.status.loading = false;
    draftState.status.errors = [];
    if (Array.isArray(data)) {
      draftState.logs = data;
    } else {
      draftState.status.errors.push('Invalid Audit Log data in response.');
    }
  }),
  [`${Actions.LOAD_AUDIT_LOGS_TASK}_REJECTED`]: (state, action) => produce(state, draftState => {
    draftState.status.loading = false;
    draftState.status.errors.push(`Failed to retrieve logs: ${errorMessageFromResponse(action)}`);
  }),
  [`${Actions.LOAD_AUDIT_LOGS_COUNT_TASK}_PENDING`]: state => produce(state, draftState => {
    draftState.status.loading = true;
  }),
  [`${Actions.LOAD_AUDIT_LOGS_COUNT_TASK}_FULFILLED`]: (state, action) => produce(state, draftState => {
    const { payload: { data } } = action;
    draftState.status.loading = false;
    draftState.status.errors = [];
    if (Number.isInteger(data)) {
      draftState.count = data;
    }
  }),
  [`${Actions.LOAD_AUDIT_LOGS_COUNT_TASK}_REJECTED`]: (state, action) => produce(state, draftState => {
    draftState.status.loading = false;
    draftState.status.errors.push(`Failed to retrieve logs count: ${errorMessageFromResponse(action)}`);
  }),
  [`${Actions.LOAD_AUDIT_LOG_TOPIC_ACTION_OPTIONS}_PENDING`]: state => produce(state, draftState => {
    draftState.status.loading = true;
  }),
  [`${Actions.LOAD_AUDIT_LOG_TOPIC_ACTION_OPTIONS}_FULFILLED`]: (state, action) => produce(state, draftState => {
    const { payload: { data } } = action;
    draftState.status.loading = false;
    draftState.status.errors = [];
    if (Array.isArray(data?.topicsAndActions)) {
      draftState.topicActionOptions = data.topicsAndActions;
    } else {
      draftState.status.errors.push('Invalid Action options from server.');
    }
  }),
  [`${Actions.LOAD_AUDIT_LOG_TOPIC_ACTION_OPTIONS}_REJECTED`]: (state, action) => produce(state, draftState => {
    draftState.status.loading = false;
    draftState.status.errors.push(`Failed to retrieve topics and actions: ${errorMessageFromResponse(action)}`);
  }),
  [`${Actions.LOAD_AUDIT_LOG_USER_OPTIONS}_PENDING`]: state => produce(state, draftState => {
    draftState.status.loading = true;
  }),
  [`${Actions.LOAD_AUDIT_LOG_USER_OPTIONS}_FULFILLED`]: (state, action) => produce(state, draftState => {
    const { payload: { data } } = action;
    draftState.status.loading = false;
    draftState.status.errors = [];
    if (data?.actingUsers) {
      const userOptions: UserSelectOption[] = data.actingUsers;
      draftState.userOptions = _.sortBy(userOptions, u => u.label);
    } else {
      draftState.status.errors.push('Invalid user options returned from the server.');
    }
  }),
  [`${Actions.LOAD_AUDIT_LOG_USER_OPTIONS}_REJECTED`]: (state, action) => produce(state, draftState => {
    draftState.status.loading = false;
    draftState.status.errors.push(`Failed to retrieve user options: ${errorMessageFromResponse(action)}`);
  }),
});
